import type {AddressSuggestParams as AddressSuggestRequest} from '@yandex-delivery/api/service/suggest'

import {type LocationRequest, fetchDetectLocationByCity} from '../../deprecated/fetch-detect-location-by-city'
import {type AddressPin, type PickupPointCity, isUserAddressPin} from '../../models/pickup-route'
import {toCity, toDetectCityRequest} from './mappers/toCity'
import type {PickupRouteServiceParams} from './types'

export function createCityService(params: PickupRouteServiceParams) {
  const {
    suggestService: {fetchAddressSuggest},
  } = params

  return {
    async fetchCity(addressPin: AddressPin): Promise<PickupPointCity> {
      const location = addressPin.coordinates as LocationRequest['location']

      if (isUserAddressPin(addressPin)) {
        return fetchDetectLocationByCity({
          type: 'a',
          location,
          text: addressPin.city,
        }) //
          .then(toCity)
      }

      const request: AddressSuggestRequest = {
        type: 'a',
        location,
        point: location,
        // @ts-expect-error TS2322: Type '"pin_drop"' is not assignable to type 'SuggestAction | undefined'.
        action: 'pin_drop',
      }

      return fetchAddressSuggest(request)
        .then(toDetectCityRequest(request))
        .then(fetchDetectLocationByCity)
        .then(toCity)
    },
  }
}
